import React, { useContext } from 'react';
import { Form } from 'rsuite';
import { Bread } from './components/Bread';
import { CategoriesPanel } from './components/CategoriesPanel';
import { Items } from './components/Items';
import { SideFilters } from './components/SideFilters';
import { ToolbarFilters } from './components/ToolbarFilters';
import { ToolbarOrder } from './components/ToolbarOrder';
import { ToolbarViewSwitcher } from './components/ToolbarViewSwitcher';
import { EquipmentContext } from './utils/scope';

export const Equipment = () => {
  const isParts = useContext(EquipmentContext) === 'parts';

  return (
    <>
      <Bread />

      <CategoriesPanel />

      <Form className="nh-form">
        {!isParts ? (
          <>
            <ToolbarFilters />

            <div className="nh-toolbar-right">
              <ToolbarViewSwitcher />
              <ToolbarOrder />
            </div>
          </>
        ) : (
          <>
            <div />
            <div className="nh-toolbar-right nh-toolbar-right--line">
              <ToolbarViewSwitcher />
              <ToolbarOrder />
            </div>
          </>
        )}
      </Form>

      <div className="nh-body">
        {isParts && (
          <Form className="nh-form nh-form--side">
            <SideFilters />
          </Form>
        )}
        <Items />
      </div>
    </>
  );
};
